webpackJsonp([0],{

/***/ "./lib/Details/Activity.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__haroenv_react_sparklines__ = __webpack_require__("../../node_modules/@haroenv/react-sparklines/build/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__haroenv_react_sparklines___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__haroenv_react_sparklines__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__("./lib/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__("./lib/Details/index.js");
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();






var threeMonths = 12; // 4 weeks * 3 = 12

var commitsLastThreeMonths = function commitsLastThreeMonths(_ref) {
  var weeklyData = _ref.weeklyData;
  return weeklyData.slice(-(threeMonths + 1));
};

var countCommitsLastThreeMonths = function countCommitsLastThreeMonths(_ref2) {
  var weeklyData = _ref2.weeklyData;
  return commitsLastThreeMonths({ weeklyData: weeklyData }).reduce(function (acc, _ref3) {
    var total = _ref3.total;
    return acc + total;
  }, 0);
};

var commitsPerWeekLastThreeMonths = function commitsPerWeekLastThreeMonths(_ref4) {
  var weeklyData = _ref4.weeklyData;
  return commitsLastThreeMonths({ weeklyData: weeklyData }).map(function (week) {
    return week.total;
  });
};

var weeksAgoSinceLastCommit = function weeksAgoSinceLastCommit(_ref5) {
  var weeklyData = _ref5.weeklyData;
  return formatWeeksSinceLastCommit(weeklyData.slice().reverse().findIndex(function (_ref6) {
    var total = _ref6.total;
    return total !== 0;
  }));
};

var formatWeeksSinceLastCommit = function formatWeeksSinceLastCommit(weeks) {
  if (weeks === -1) {
    return window.i18n.detail.over_a_year_ago;
  }
  if (weeks < 1) {
    return window.i18n.detail.less_than_a_week_ago;
  }
  if (weeks === 1) {
    return window.i18n.detail.one_week_ago;
  }
  return window.i18n.detail.weeks_ago.replace('{count}', weeks);
};

var _ref8 = _jsx(__WEBPACK_IMPORTED_MODULE_1__haroenv_react_sparklines__["SparklinesLine"], {
  color: '#2C8EBB'
});

var Activity = function Activity(_ref7) {
  var _ref7$data = _ref7.data,
      data = _ref7$data === undefined ? [] : _ref7$data,
      githubRepo = _ref7.githubRepo;

  if (Object(__WEBPACK_IMPORTED_MODULE_2__util__["g" /* isEmpty */])(data)) {
    return null;
  }
  return _jsx('article', {
    className: 'details-side--activity'
  }, void 0, _jsx('h1', {}, void 0, window.i18n.detail.activity), _jsx('a', {
    href: 'https://github.com/' + Object(__WEBPACK_IMPORTED_MODULE_2__util__["c" /* encode */])(githubRepo.user) + '/' + Object(__WEBPACK_IMPORTED_MODULE_2__util__["c" /* encode */])(githubRepo.project) + '/graphs/commit-activity',
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1__haroenv_react_sparklines__["Sparklines"], {
    data: commitsPerWeekLastThreeMonths({ weeklyData: data }),
    width: 100,
    height: 15
  }, void 0, _ref8)), _jsx('dl', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_3____["a" /* Di */], {
    icon: 'commits',
    title: window.i18n.detail.commits_last_three_months,
    description: countCommitsLastThreeMonths({ weeklyData: data })
  }), _jsx(__WEBPACK_IMPORTED_MODULE_3____["a" /* Di */], {
    icon: 'commits-last',
    title: window.i18n.detail.last_commit,
    description: weeksAgoSinceLastCommit({ weeklyData: data })
  })));
};

/* harmony default export */ __webpack_exports__["a"] = (Activity);

/***/ }),

/***/ "./lib/Details/Aside.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Install__ = __webpack_require__("./lib/Details/Install.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Links__ = __webpack_require__("./lib/Details/Links.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Activity__ = __webpack_require__("./lib/Details/Activity.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Popularity__ = __webpack_require__("./lib/Details/Popularity.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Usage__ = __webpack_require__("./lib/Details/Usage.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Versions__ = __webpack_require__("./lib/Details/Versions.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Contributors__ = __webpack_require__("./lib/Details/Contributors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Tags__ = __webpack_require__("./lib/Details/Tags.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__("./lib/util.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();













var Aside = function Aside(_ref) {
  var name = _ref.name,
      homepage = _ref.homepage,
      githubRepo = _ref.githubRepo,
      contributors = _ref.contributors,
      activity = _ref.activity,
      downloads = _ref.downloads,
      humanDownloads = _ref.humanDownloads,
      stargazers = _ref.stargazers,
      dependents = _ref.dependents,
      humanDependents = _ref.humanDependents,
      dependencies = _ref.dependencies,
      tags = _ref.tags,
      versions = _ref.versions,
      devDependencies = _ref.devDependencies,
      onOpenFileBrowser = _ref.onOpenFileBrowser;
  return _jsx('aside', {
    className: 'details-side col-lg-4'
  }, void 0, _jsx('article', {
    className: 'details-side--links'
  }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Links__["a" /* default */], {
    name: name,
    homepage: homepage,
    githubRepo: githubRepo
  })), _jsx(__WEBPACK_IMPORTED_MODULE_1__Install__["a" /* default */], {
    name: name,
    onOpenFileBrowser: onOpenFileBrowser
  }), _jsx(__WEBPACK_IMPORTED_MODULE_4__Popularity__["a" /* default */], {
    downloads: downloads,
    humanDownloads: humanDownloads,
    stargazers: stargazers,
    dependents: dependents,
    humanDependents: humanDependents,
    name: name
  }), githubRepo && githubRepo.user && githubRepo.project && _jsx(__WEBPACK_IMPORTED_MODULE_3__Activity__["a" /* default */], {
    data: activity,
    githubRepo: githubRepo
  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Usage__["a" /* default */], _extends({
    dependencies: dependencies,
    devDependencies: devDependencies
  }, Object(__WEBPACK_IMPORTED_MODULE_9__util__["h" /* packageJSONLink */])({ githubRepo: githubRepo }))), _jsx(__WEBPACK_IMPORTED_MODULE_8__Tags__["a" /* default */], {
    tags: tags,
    name: name
  }), _jsx(__WEBPACK_IMPORTED_MODULE_6__Versions__["a" /* default */], {
    versions: versions
  }), _jsx(__WEBPACK_IMPORTED_MODULE_7__Contributors__["a" /* default */], {
    contributors: contributors
  }));
};

/* harmony default export */ __webpack_exports__["a"] = (Aside);

/***/ }),

/***/ "./lib/Details/Contributors.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Hit__ = __webpack_require__("./lib/Hit/index.js");
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Contributors = function (_Component) {
  _inherits(Contributors, _Component);

  function Contributors() {
    _classCallCheck(this, Contributors);

    return _possibleConstructorReturn(this, (Contributors.__proto__ || Object.getPrototypeOf(Contributors)).apply(this, arguments));
  }

  _createClass(Contributors, [{
    key: 'render',
    value: function render() {
      var contributors = this.props.contributors;

      return _jsx('article', {
        className: 'details-side--contributors'
      }, void 0, _jsx('h1', {}, void 0, window.i18n.detail.contributors), _jsx('ul', {
        className: 'list-unstyled m-2'
      }, void 0, contributors.map(function (contributor) {
        return _jsx('li', {
          className: 'mb-1'
        }, contributor.name, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Hit__["d" /* Owner */], contributor));
      })));
    }
  }]);

  return Contributors;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Contributors);

/***/ }),

/***/ "./lib/Details/Copyable.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var images = {
  default: '/assets/detail/ico-copy-default.svg',
  success: '/assets/detail/ico-copy-success.svg'
};

var Copyable = function (_Component) {
  _inherits(Copyable, _Component);

  function Copyable(props) {
    _classCallCheck(this, Copyable);

    var _this = _possibleConstructorReturn(this, (Copyable.__proto__ || Object.getPrototypeOf(Copyable)).call(this, props));

    _this.state = {
      statusImage: images.default
    };
    return _this;
  }

  _createClass(Copyable, [{
    key: 'copy',
    value: function copy(toCopy) {
      var _this2 = this;

      var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2000;

      var setAndUnset = function setAndUnset(_ref) {
        var image = _ref.image,
            timeout = _ref.timeout;

        _this2.setState(function () {
          return {
            statusImage: image
          };
        });
        setTimeout(function () {
          _this2.setState(function () {
            return {
              statusImage: images.default
            };
          });
        }, timeout);
      };

      var range = document.createRange();
      range.selectNode(toCopy);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      try {
        // Now that we've selected the anchor text, execute the copy command
        var copy = document.execCommand('copy');
        window.getSelection().removeAllRanges();
        if (copy === true) {
          setAndUnset({ image: images.success, timeout: timeout });
        }
      } catch (err) {
        this.setState(function () {
          return {
            statusImage: images.default
          };
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          _props$tag = _props.tag,
          tag = _props$tag === undefined ? 'div' : _props$tag,
          pre = _props.pre,
          children = _props.children;

      var Content = tag;
      return _jsx('div', {
        className: 'copyable'
      }, void 0, _jsx(Content, {
        className: 'copyable--content'
      }, void 0, pre, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { ref: function ref(text) {
            return _this3.copyText = text;
          } },
        children
      )), _jsx('button', {
        onClick: function onClick() {
          return _this3.copy(_this3.copyText);
        },
        className: 'copyable--button user-select-none'
      }, void 0, _jsx('img', {
        src: this.state.statusImage,
        alt: '',
        className: 'copyable--button__img'
      }), 'copy'));
    }
  }]);

  return Copyable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Copyable);

/***/ }),

/***/ "./lib/Details/FileBrowser.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_transition_group_CSSTransitionGroup__ = __webpack_require__("../../node_modules/react-transition-group/CSSTransitionGroup.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_transition_group_CSSTransitionGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_transition_group_CSSTransitionGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_unfetch__ = __webpack_require__("../../node_modules/unfetch/dist/unfetch.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bytes__ = __webpack_require__("../../node_modules/bytes/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bytes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bytes__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var SORT_ORDER = { directory: 1, file: 2 };

function getBasename(path) {
  return path.substr(path.lastIndexOf('/') + 1);
}

var FileBrowser = function (_React$PureComponent) {
  _inherits(FileBrowser, _React$PureComponent);

  function FileBrowser() {
    _classCallCheck(this, FileBrowser);

    var _this = _possibleConstructorReturn(this, (FileBrowser.__proto__ || Object.getPrototypeOf(FileBrowser)).call(this));

    _this._toggleDir = function (dir) {
      var shouldBeExpanded = !_this.state.expandedDirs[dir.path];
      _this.setState({
        expandedDirs: _extends({}, _this.state.expandedDirs, _defineProperty({}, dir.path, shouldBeExpanded))
      });
    };

    _this._setBackRef = function (ref) {
      _this._backRef = ref;
    };

    _this.state = {
      expandedDirs: {
        '/': true
      }
    };
    return _this;
  }

  _createClass(FileBrowser, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._fetchFiles();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this._backRef) {
        this._backRef.focus();
      }
    }
  }, {
    key: '_fetchFiles',
    value: function _fetchFiles() {
      var _this2 = this;

      this.setState({ error: null, files: null });
      var url = this._getBaseURL() + '?meta';
      Object(__WEBPACK_IMPORTED_MODULE_2_unfetch__["a" /* default */])(url).then(function (response) {
        return response.json();
      }).then(function (files) {
        return _this2.setState({ files: files });
      }, function (error) {
        return _this2.setState({ error: error });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _jsx('div', {}, void 0, _jsx('h2', {
        className: 'm-2'
      }, void 0, window.i18n.detail.files_header.replace('{name}', this.props.objectID)), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'a',
        { href: '#', ref: this._setBackRef, onClick: this.props.onBackToDetails },
        '\u2190 ',
        window.i18n.detail.back_to_details
      ), this._renderInner());
    }
  }, {
    key: '_renderInner',
    value: function _renderInner() {
      if (this.state.files) {
        return _jsx(Directory, {
          baseURL: this._getBaseURL(),
          dir: this.state.files,
          expandedDirs: this.state.expandedDirs,
          onToggleDir: this._toggleDir
        });
      }
      if (this.state.error) {
        return _jsx('div', {
          className: 'alert alert-danger',
          role: 'alert'
        }, void 0, window.i18n.detail.files_error.replace('{error}', this.state.error.message));
      }
      return _jsx('div', {}, void 0, window.i18n.detail.loading);
    }
  }, {
    key: '_getBaseURL',
    value: function _getBaseURL() {
      return 'https://unpkg.com/' + this.props.objectID + '@' + this.props.version + '/';
    }
  }]);

  return FileBrowser;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.PureComponent);

/* harmony default export */ __webpack_exports__["a"] = (FileBrowser);

var Directory = function (_React$PureComponent2) {
  _inherits(Directory, _React$PureComponent2);

  function Directory() {
    var _ref;

    var _temp, _this3, _ret;

    _classCallCheck(this, Directory);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this3 = _possibleConstructorReturn(this, (_ref = Directory.__proto__ || Object.getPrototypeOf(Directory)).call.apply(_ref, [this].concat(args))), _this3), _this3._toggleDir = function (evt) {
      _this3.props.onToggleDir(_this3.props.dir);
      evt.preventDefault();
    }, _temp), _possibleConstructorReturn(_this3, _ret);
  }

  _createClass(Directory, [{
    key: 'render',
    value: function render() {
      var dir = this.props.dir;
      var url = this.props.baseURL + dir.path.substr(1) + '/';
      if (dir.path === '/') {
        // Special case for root - Only render the contents, not the outer
        // wrapper.
        return this._renderDirContents();
      }
      return _jsx('li', {}, dir.path, _jsx('a', {
        className: 'details-files__dirname',
        href: url,
        target: '_blank',
        rel: 'noopener noreferrer',
        onClick: this._toggleDir
      }, void 0, getBasename(dir.path)), _jsx(__WEBPACK_IMPORTED_MODULE_0_react_transition_group_CSSTransitionGroup___default.a, {
        transitionName: 'details-files',
        transitionEnterTimeout: 600,
        transitionLeaveTimeout: 600
      }, void 0, this._renderDirContents()));
    }
  }, {
    key: '_renderDirContents',
    value: function _renderDirContents() {
      var _this4 = this;

      if (!this.props.expandedDirs[this.props.dir.path]) {
        return null;
      }
      var files = this.props.dir.files;

      files.sort(function (a, b) {
        // Sort by type (directories to the top)
        if (a.type !== b.type) {
          return SORT_ORDER[a.type] - SORT_ORDER[b.type];
        }
        // Then sort by filename, case insensitive
        return a.path.localeCompare(b.path, 'en', { sensitivity: 'base' });
      });

      return _jsx('ul', {
        className: 'details-files__list'
      }, void 0, files.map(function (file) {
        if (file.type === 'directory') {
          return _jsx(Directory, {
            baseURL: _this4.props.baseURL,
            dir: file,
            expandedDirs: _this4.props.expandedDirs,
            onToggleDir: _this4.props.onToggleDir
          }, file.path);
        } else {
          return _jsx(File, {
            file: file,
            url: _this4.props.baseURL + file.path.substr(1),
            size: file.size
          }, file.path);
        }
      }));
    }
  }]);

  return Directory;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.PureComponent);

var File = function File(_ref2) {
  var file = _ref2.file,
      url = _ref2.url,
      size = _ref2.size;
  return _jsx('li', {
    className: 'd-flex justify-items-between align-items-baseline'
  }, file.path, _jsx('a', {
    className: 'details-files__filename',
    href: url,
    target: '_blank'
  }, void 0, getBasename(file.path)), _jsx('small', {}, void 0, __WEBPACK_IMPORTED_MODULE_3_bytes___default()(size)));
};

/***/ }),

/***/ "./lib/Details/Header.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Hit__ = __webpack_require__("./lib/Hit/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__("./lib/util.js");
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();





var Description = function Description(_ref) {
  var description = _ref.description,
      deprecated = _ref.deprecated;
  return _jsx('div', {}, void 0, deprecated ? _jsx('p', {
    className: 'm-2'
  }, void 0, _jsx('strong', {
    dangerouslySetInnerHTML: Object(__WEBPACK_IMPORTED_MODULE_2__util__["k" /* safeMarkdown */])(deprecated)
  })) : null, _jsx('p', {
    className: 'm-2 lead',
    dangerouslySetInnerHTML: Object(__WEBPACK_IMPORTED_MODULE_2__util__["k" /* safeMarkdown */])(description)
  }));
};

var Header = function Header(_ref2) {
  var name = _ref2.name,
      owner = _ref2.owner,
      downloadsLast30Days = _ref2.downloadsLast30Days,
      humanDownloadsLast30Days = _ref2.humanDownloadsLast30Days,
      description = _ref2.description,
      license = _ref2.license,
      deprecated = _ref2.deprecated,
      keywords = _ref2.keywords,
      version = _ref2.version;
  return _jsx('header', {
    className: 'details-main--header'
  }, void 0, _jsx('h2', {
    className: 'details-main--title d-inline-block m-2'
  }, void 0, name), _jsx('div', {
    className: 'details-main--info d-inline-block m-2'
  }, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Hit__["d" /* Owner */], owner), _jsx(__WEBPACK_IMPORTED_MODULE_1__Hit__["b" /* Downloads */], {
    downloads: downloadsLast30Days,
    humanDownloads: humanDownloadsLast30Days
  }), _jsx(__WEBPACK_IMPORTED_MODULE_1__Hit__["c" /* License */], {
    type: license
  }), _jsx(__WEBPACK_IMPORTED_MODULE_1__Hit__["a" /* Deprecated */], {
    deprecated: deprecated
  }), _jsx('span', {
    className: 'ais-Hit--version'
  }, void 0, version)), _jsx(Description, {
    description: description,
    deprecated: deprecated
  }), _jsx(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* Keywords */], {
    keywords: keywords
  }));
};

/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),

/***/ "./lib/Details/Install.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Copyable__ = __webpack_require__("./lib/Details/Copyable.js");
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Install = function (_Component) {
  _inherits(Install, _Component);

  function Install() {
    _classCallCheck(this, Install);

    return _possibleConstructorReturn(this, (Install.__proto__ || Object.getPrototypeOf(Install)).apply(this, arguments));
  }

  _createClass(Install, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          name = _props.name,
          onOpenFileBrowser = _props.onOpenFileBrowser;

      return _jsx('article', {
        className: 'details-side--copy'
      }, void 0, _jsx('h1', {}, void 0, window.i18n.detail.use_it), _jsx(__WEBPACK_IMPORTED_MODULE_1__Copyable__["a" /* default */], {
        pre: '$ ',
        tag: 'code'
      }, void 0, 'yarn add ', name), _jsx('div', {}, void 0, _jsx('a', {
        className: 'details-side--runkit',
        href: 'https://runkit.com/npm/' + name,
        target: '_blank',
        rel: 'noopener noreferrer'
      }, void 0, window.i18n.detail.try_in_runkit), ' · ', _jsx('a', {
        href: '#',
        onClick: onOpenFileBrowser
      }, void 0, window.i18n.detail.browse_files)));
    }
  }]);

  return Install;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Install);

/***/ }),

/***/ "./lib/Details/JSONLDItem.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__("./lib/util.js");
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




/**
 * JSON-ld is a technology that allows crawlers to get info about
 * documents on the web, in a more structured way that microdata.
 * 
 * Here we use schema.org's documents that describe a SoftwareApplication
 * of the type DeveloperApplication. It takes the description, name
 * url etc from this package data. 
 * 
 * Crawlers like Google can take this data and then display the Yarn
 * detail page however they want Software to look.
 * 
 * At this point Google etc. doesn't display it separately yet, but since
 * both Yarn, npm and other sites include this information, they might
 * very well in the future.
 * 
 * read more about it on: http://json-ld.org
 */

var JSONLDItem = function JSONLDItem(_ref) {
  var name = _ref.name,
      description = _ref.description,
      keywords = _ref.keywords;
  return _jsx('script', {
    type: 'application/ld+json'
  }, void 0, JSON.stringify({
    '@context': 'http://schema.org',
    '@type': 'SoftwareApplication',
    name: name,
    description: description,
    url: Object(__WEBPACK_IMPORTED_MODULE_1__util__["i" /* packageLink */])(name),
    keywords: keywords.join(','),
    applicationCategory: 'DeveloperApplication',
    offers: {
      '@type': 'Offer',
      price: '0.00'
    }
  }));
};

/* harmony default export */ __webpack_exports__["a"] = (JSONLDItem);

/***/ }),

/***/ "./lib/Details/Links.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Link */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__("./lib/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Copyable__ = __webpack_require__("./lib/Details/Copyable.js");
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();






var images = {
  homepage: '/assets/search/ico-home.svg',
  npm: '/assets/search/ico-npm.svg',
  github: '/assets/search/ico-github.svg',
  yarn: '/assets/search/ico-yarn.svg'
};

var Link = function Link(_ref) {
  var site = _ref.site,
      url = _ref.url,
      display = _ref.display,
      _ref$Tag = _ref.Tag,
      Tag = _ref$Tag === undefined ? 'a' : _ref$Tag;
  return _jsx(Tag, {
    target: '_blank',
    rel: 'noopener noreferrer',
    href: url,
    className: 'details-links--link details-links--link__' + site
  }, void 0, _jsx('img', {
    src: images[site],
    alt: ''
  }), display);
};

var _ref3 = _jsx('span', {
  className: 'text-hide'
}, void 0, 'https://');

var Links = function Links(_ref2) {
  var name = _ref2.name,
      homepage = _ref2.homepage,
      githubRepo = _ref2.githubRepo,
      className = _ref2.className;
  return _jsx('div', {
    className: 'detail-links'
  }, void 0, _jsx(Link, {
    site: 'yarn',
    display: _jsx(__WEBPACK_IMPORTED_MODULE_2__Copyable__["a" /* default */], {}, void 0, _jsx('a', {
      href: 'https://yarn.pm/' + name
    }, void 0, _ref3, 'yarn.pm/', name)),
    Tag: 'div'
  }), homepage ? _jsx(Link, {
    site: 'homepage',
    url: homepage,
    display: homepage.replace(/(http)?s?(:\/\/)?(www\.)?/, '')
  }) : null, githubRepo ? _jsx(Link, {
    site: 'github',
    url: 'https://github.com/' + Object(__WEBPACK_IMPORTED_MODULE_1__util__["c" /* encode */])(githubRepo.user) + '/' + Object(__WEBPACK_IMPORTED_MODULE_1__util__["c" /* encode */])(githubRepo.project) + githubRepo.path,
    display: githubRepo.user + '/' + githubRepo.project
  }) : null, _jsx(Link, {
    site: 'npm',
    url: 'https://www.npmjs.com/package/' + name,
    display: name
  }));
};

/* harmony default export */ __webpack_exports__["a"] = (Links);

/***/ }),

/***/ "./lib/Details/Markdown.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_marked__ = __webpack_require__("../../node_modules/marked/lib/marked.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_marked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_xss__ = __webpack_require__("../../node_modules/xss/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_xss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_xss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__("./lib/util.js");
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







var GITHUB = {
  main: 'https://github.com',
  raw: 'https://raw.githubusercontent.com'
};

__WEBPACK_IMPORTED_MODULE_1_marked___default.a.Lexer.rules.gfm.heading = __WEBPACK_IMPORTED_MODULE_1_marked___default.a.Lexer.rules.normal.heading;
__WEBPACK_IMPORTED_MODULE_1_marked___default.a.Lexer.rules.tables.heading = __WEBPACK_IMPORTED_MODULE_1_marked___default.a.Lexer.rules.normal.heading;

var renderAndEscapeMarkdown = function renderAndEscapeMarkdown(_ref) {
  var source = _ref.source,
      githubRepo = _ref.githubRepo;

  var renderer = new __WEBPACK_IMPORTED_MODULE_1_marked___default.a.Renderer();

  if (githubRepo) {
    var user = githubRepo.user,
        project = githubRepo.project,
        path = githubRepo.path,
        head = githubRepo.head;

    var prefix = function prefix(href, base) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__util__["j" /* prefixURL */])(href, {
        base: base,
        user: user,
        project: project,
        head: head ? head : 'master',
        path: path
      });
    };

    renderer.image = function (href, title, text) {
      return '<img src="' + prefix(href, GITHUB.raw) + '" title="' + title + '" alt="' + text + '"/>';
    };

    renderer.link = function (href, title, text) {
      return '<a href="' + prefix(href, GITHUB.main) + '" title="' + title + '">' + text + '</a>';
    };

    renderer.html = function (html) {
      return html.replace(/(src|href)="([^"]*)/g, function (match, type, href) {
        return type + '="' + prefix(href, type === 'href' ? GITHUB.main : GITHUB.raw);
      });
    };
  }

  var html = __WEBPACK_IMPORTED_MODULE_1_marked___default()(source, { renderer: renderer });
  var escaped = __WEBPACK_IMPORTED_MODULE_2_xss___default()(html);
  return escaped;
};

var Markdown = function Markdown(_ref2) {
  var source = _ref2.source,
      githubRepo = _ref2.githubRepo;
  return _jsx('article', {
    dangerouslySetInnerHTML: {
      __html: renderAndEscapeMarkdown({
        source: source,
        githubRepo: githubRepo
      })
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Markdown);

/***/ }),

/***/ "./lib/Details/Popularity.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__("./lib/Details/index.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Stargazers = function Stargazers(_ref) {
  var stargazers = _ref.stargazers;
  return stargazers >= 0 && _jsx(__WEBPACK_IMPORTED_MODULE_1____["a" /* Di */], {
    icon: 'stargazers',
    title: window.i18n.detail.github_stargazers,
    description: stargazers.toLocaleString(window.i18n.active_language)
  });
};

var Downloads = function Downloads(_ref2) {
  var downloads = _ref2.downloads,
      humanDownloads = _ref2.humanDownloads;
  return downloads >= 0 && humanDownloads && _jsx(__WEBPACK_IMPORTED_MODULE_1____["a" /* Di */], {
    icon: 'downloads',
    title: window.i18n.detail.downloads_last_30_days,
    description: _jsx('span', {
      title: downloads.toLocaleString(window.i18n.active_language)
    }, void 0, humanDownloads)
  });
};

var Dependents = function Dependents(_ref3) {
  var dependents = _ref3.dependents,
      humanDependents = _ref3.humanDependents,
      name = _ref3.name;
  return dependents >= 0 && _jsx(__WEBPACK_IMPORTED_MODULE_1____["a" /* Di */], {
    icon: 'dependents',
    title: window.i18n.detail.dependents,
    description: _jsx('a', {
      href: 'https://www.npmjs.com/browse/depended/' + name,
      target: '_blank',
      rel: 'noopener noreferrer',
      title: dependents.toLocaleString(window.i18n.active_language)
    }, void 0, humanDependents)
  });
};

var Popularity = function (_Component) {
  _inherits(Popularity, _Component);

  function Popularity() {
    _classCallCheck(this, Popularity);

    return _possibleConstructorReturn(this, (Popularity.__proto__ || Object.getPrototypeOf(Popularity)).apply(this, arguments));
  }

  _createClass(Popularity, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          name = _props.name,
          stargazers = _props.stargazers,
          downloads = _props.downloads,
          humanDownloads = _props.humanDownloads,
          dependents = _props.dependents,
          humanDependents = _props.humanDependents;


      if (downloads >= 0 || dependents >= 0 || stargazers >= 0) {
        return _jsx('article', {
          className: 'details-side--popularity'
        }, void 0, _jsx('h1', {}, void 0, window.i18n.detail.popularity), _jsx('dl', {}, void 0, _jsx(Stargazers, {
          stargazers: stargazers
        }), _jsx(Downloads, {
          downloads: downloads,
          humanDownloads: humanDownloads
        }), _jsx(Dependents, {
          dependents: dependents,
          humanDependents: humanDependents,
          name: name
        })));
      }
      return null;
    }
  }]);

  return Popularity;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Popularity);

/***/ }),

/***/ "./lib/Details/ReadMore.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var ReadMore = function (_React$Component) {
  _inherits(ReadMore, _React$Component);

  function ReadMore(props) {
    _classCallCheck(this, ReadMore);

    var _this = _possibleConstructorReturn(this, (ReadMore.__proto__ || Object.getPrototypeOf(ReadMore)).call(this, props));

    _this.toggleCollapse = function () {
      _this.setState({
        collapsed: !_this.state.collapsed
      });
    };

    _this.maxHeight = props.height + 'px';
    _this.state = {
      collapsed: true,
      collapsible: true
    };
    return _this;
  }

  _createClass(ReadMore, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      var _content$getBoundingC = this.content.getBoundingClientRect(),
          height = _content$getBoundingC.height;

      if (nextState.collapsible && height < nextProps.height) {
        this.setState({
          collapsible: false,
          collapsed: false
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          text = _props.text,
          className = _props.className;
      var _state = this.state,
          collapsed = _state.collapsed,
          collapsible = _state.collapsible;


      return _jsx('div', {
        className: className + ' readMore ' + (collapsed ? 'readMore--collapsed' : '')
      }, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: 'readMore--content',
          style: { maxHeight: collapsed ? this.maxHeight : '' },
          ref: function ref(div) {
            return _this2.content = div;
          }
        },
        children
      ), collapsible && _jsx('button', {
        className: 'readMore--button',
        onClick: this.toggleCollapse
      }, void 0, collapsed ? text : window.i18n.detail.collapse, _jsx('img', {
        src: '/assets/detail/ico-readmore.svg',
        alt: '',
        className: 'readMore--icon',
        style: { transform: collapsed ? '' : 'rotate(180deg)' }
      })));
    }
  }]);

  return ReadMore;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ReadMore.defaultProps = {
  height: 250,
  className: ''
};

/* harmony default export */ __webpack_exports__["a"] = (ReadMore);

/***/ }),

/***/ "./lib/Details/Tags.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__("./lib/Details/index.js");
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Tags = function (_Component) {
  _inherits(Tags, _Component);

  function Tags() {
    _classCallCheck(this, Tags);

    return _possibleConstructorReturn(this, (Tags.__proto__ || Object.getPrototypeOf(Tags)).apply(this, arguments));
  }

  _createClass(Tags, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          tags = _props.tags,
          name = _props.name;

      var tagNames = Object.keys(tags);
      if (tagNames.length === 0) {
        return null;
      }

      return _jsx('article', {
        className: 'details-side--tags'
      }, void 0, _jsx('h1', {}, void 0, window.i18n.detail.tags), _jsx('dl', {}, void 0, tagNames.map(function (tag) {
        return _jsx(__WEBPACK_IMPORTED_MODULE_1____["a" /* Di */], {
          title: _jsx('code', {}, void 0, tag),
          description: tags[tag]
        }, tag);
      })));
    }
  }]);

  return Tags;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Tags);

/***/ }),

/***/ "./lib/Details/Usage.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__("./lib/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__("./lib/Details/index.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();





var deps = function deps(_ref) {
  var dependencies = _ref.dependencies,
      title = _ref.title;

  if (dependencies) {
    var dependencyNames = Object.keys(dependencies);

    return {
      title: dependencyNames.length > 0 ? _jsx('details', {}, void 0, _jsx('summary', {}, void 0, title), dependencyNames.map(function (name, index) {
        return _jsx('a', {
          href: Object(__WEBPACK_IMPORTED_MODULE_1__util__["i" /* packageLink */])(name),
          title: name + '@' + dependencies[name]
        }, index, name);
      }).reduce(function (prev, curr) {
        return [prev, ', ', curr];
      })) : title,
      description: dependencyNames.length
    };
  }
  return {};
};

var Usage = function Usage(_ref2) {
  var dependencies = _ref2.dependencies,
      devDependencies = _ref2.devDependencies,
      packageJSONLink = _ref2.packageJSONLink,
      versions = _ref2.versions;
  return _jsx('article', {
    className: 'details-side--usage'
  }, void 0, _jsx('h1', {}, void 0, window.i18n.detail.usage), _jsx('dl', {}, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["a" /* Di */], _extends({
    icon: 'dependencies'
  }, deps({
    title: window.i18n.detail.dependencies,
    dependencies: dependencies
  }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["a" /* Di */], _extends({
    icon: 'devdependencies'
  }, deps({
    title: window.i18n.detail.devdependencies,
    dependencies: devDependencies
  }))), packageJSONLink && _jsx(__WEBPACK_IMPORTED_MODULE_2____["a" /* Di */], {
    icon: 'package-json',
    title: window.i18n.detail.packages,
    description: _jsx('a', {
      target: '_blank',
      rel: 'noopener noreferrer',
      href: packageJSONLink
    }, void 0, window.i18n.detail.see_package_json)
  })));
};

/* harmony default export */ __webpack_exports__["a"] = (Usage);

/***/ }),

/***/ "./lib/Details/Versions.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__("./lib/Details/index.js");
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var _localeVersion = function _localeVersion(pubDate) {
  return new Date(pubDate).toLocaleDateString(window.i18n.active_language, {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

var Versions = function (_Component) {
  _inherits(Versions, _Component);

  function Versions(props) {
    _classCallCheck(this, Versions);

    var _this = _possibleConstructorReturn(this, (Versions.__proto__ || Object.getPrototypeOf(Versions)).call(this, props));

    _this.state = {
      isShowingMore: false
    };
    return _this;
  }

  _createClass(Versions, [{
    key: '_toggleShowMore',
    value: function _toggleShowMore() {
      this.setState(function (_ref) {
        var isShowingMore = _ref.isShowingMore;
        return {
          isShowingMore: !isShowingMore
        };
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var versions = this.props.versions;
      var isShowingMore = this.state.isShowingMore;

      var versionKeys = Object.keys(versions);
      var buttonText = isShowingMore ? window.i18n.detail.hide : window.i18n.detail.display_all;
      var versionsToShow = isShowingMore ? versionKeys.reverse() : versionKeys.reverse().slice(0, 3);

      return _jsx('article', {
        className: 'details-side--versions'
      }, void 0, _jsx('h1', {}, void 0, window.i18n.detail.versions), _jsx('dl', {}, void 0, versionsToShow.map(function (version) {
        return _jsx(__WEBPACK_IMPORTED_MODULE_1____["a" /* Di */], {
          title: _localeVersion(versions[version]),
          description: version
        }, version);
      })), versionKeys.length > 3 && _jsx('button', {
        onClick: function onClick() {
          return _this2._toggleShowMore();
        },
        className: 'readMore--button'
      }, void 0, buttonText, _jsx('img', {
        src: '/assets/detail/ico-readmore.svg',
        alt: '',
        className: 'readMore--icon',
        style: { transform: isShowingMore ? 'rotate(180deg)' : '' }
      })));
    }
  }]);

  return Versions;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Versions);

/***/ }),

/***/ "./lib/Details/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Di; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_algoliasearch_lite__ = __webpack_require__("../../node_modules/algoliasearch/src/browser/builds/algoliasearchLite.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_algoliasearch_lite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_algoliasearch_lite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Aside__ = __webpack_require__("./lib/Details/Aside.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FileBrowser__ = __webpack_require__("./lib/Details/FileBrowser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Copyable__ = __webpack_require__("./lib/Details/Copyable.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Header__ = __webpack_require__("./lib/Details/Header.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__JSONLDItem__ = __webpack_require__("./lib/Details/JSONLDItem.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ReadMore__ = __webpack_require__("./lib/Details/ReadMore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Markdown__ = __webpack_require__("./lib/Details/Markdown.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__schema__ = __webpack_require__("./lib/schema.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util__ = __webpack_require__("./lib/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__("./lib/config.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var client = __WEBPACK_IMPORTED_MODULE_1_algoliasearch_lite___default()(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* algolia */].appId, __WEBPACK_IMPORTED_MODULE_11__config__["a" /* algolia */].apiKey);
var index = client.initIndex(__WEBPACK_IMPORTED_MODULE_11__config__["a" /* algolia */].indexName);

var readmeErrorMessage = 'ERROR: No README data found!';

var _ref2 = _jsx('span', {
  className: 'dotted flex-grow'
});

var Di = function Di(_ref) {
  var icon = _ref.icon,
      title = _ref.title,
      description = _ref.description;
  return _jsx('div', {
    className: 'd-flex justify-items-between w-100'
  }, void 0, icon && _jsx('img', {
    src: '/assets/detail/ico-' + icon + '.svg',
    alt: ''
  }), _jsx('dt', {}, void 0, title), _ref2, _jsx('dd', {}, void 0, description));
};

function setHead(_ref3) {
  var name = _ref3.name,
      description = _ref3.description;

  var head = document.querySelector('head');
  var permalink = 'https://yarnpkg.com' + Object(__WEBPACK_IMPORTED_MODULE_10__util__["i" /* packageLink */])(name);
  head.querySelector('meta[property="og:title"]').setAttribute('content', name);
  document.title = name + ' | Yarn';
  head.querySelector('meta[name=description]').setAttribute('content', description);
  head.querySelector('meta[property="og:description"]').setAttribute('content', description);
  head.querySelector('meta[property="og:url"]').setAttribute('content', permalink);
  head.querySelector('link[rel=canonical]').setAttribute('href', permalink);
}

var OBJECT_DOESNT_EXIST = 'ObjectID does not exist';

var _ref5 = _jsx(__WEBPACK_IMPORTED_MODULE_4__Copyable__["a" /* default */], {
  pre: '$ '
}, void 0, 'yarn init');

var _ref6 = _jsx(__WEBPACK_IMPORTED_MODULE_4__Copyable__["a" /* default */], {
  pre: '$ '
}, void 0, 'yarn publish');

var Details = function (_Component) {
  _inherits(Details, _Component);

  function Details(props) {
    _classCallCheck(this, Details);

    var _this = _possibleConstructorReturn(this, (Details.__proto__ || Object.getPrototypeOf(Details)).call(this, props));

    _this._openFileBrowser = function (evt) {
      _this.setState({ isBrowsingFiles: true });
      evt.preventDefault();
    };

    _this._closeFileBrowser = function (evt) {
      _this.setState({ isBrowsingFiles: false });
      evt.preventDefault();
    };

    _this.getGithub = _this.getGithub.bind(_this);
    _this.state = _extends({}, __WEBPACK_IMPORTED_MODULE_9__schema__["a" /* default */], {
      isBrowsingFiles: false
    });
    return _this;
  }

  _createClass(Details, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      index.getObject(this.props.objectID).then(function (content) {
        _this2.setState(function (prevState) {
          return _extends({}, content, { loaded: true });
        });
        setHead(content);
        _this2.getDocuments();
      }).catch(function (e) {
        if (e.message === OBJECT_DOESNT_EXIST) {
          _this2.setState({
            objectDoesntExist: true
          });
        }
      });
    }
  }, {
    key: 'getGithub',
    value: function getGithub(_ref4) {
      var _this3 = this;

      var url = _ref4.url,
          state = _ref4.state;

      return Object(__WEBPACK_IMPORTED_MODULE_10__util__["e" /* get */])({
        url: 'https://api.github.com/' + url,
        type: 'json'
      }).then(function (res) {
        return _this3.setState(_defineProperty({}, state, res));
      }).catch(function (err) {
        if (err === 'retry') {
          setTimeout(_this3.getGithub({ url: url, state: state }), 200);
        }
      });
    }
  }, {
    key: 'getDocuments',
    value: function getDocuments() {
      var _this4 = this;

      if (this.state.githubRepo && this.state.githubRepo.user && this.state.githubRepo.project) {
        if (this.state.changelogFilename) {
          Object(__WEBPACK_IMPORTED_MODULE_10__util__["e" /* get */])({
            url: this.state.changelogFilename,
            type: 'text'
          }).then(function (res) {
            return _this4.setState({ changelog: res });
          });
        }

        if (typeof this.state.readme === 'undefined' || this.state.readme.length === 0 || this.state.readme === readmeErrorMessage) {
          Object(__WEBPACK_IMPORTED_MODULE_10__util__["e" /* get */])({
            url: Object(__WEBPACK_IMPORTED_MODULE_10__util__["j" /* prefixURL */])('README.md', {
              base: 'https://raw.githubusercontent.com',
              user: this.state.githubRepo.user,
              project: this.state.githubRepo.project,
              head: this.state.githubRepo.head ? this.state.githubRepo.head : 'master',
              path: this.state.githubRepo.path.replace(/\/tree\//, '')
            }),
            type: 'text'
          }).then(function (res) {
            return _this4.setState({ readme: res });
          });
        }

        this.getGithub({
          url: 'repos/' + this.state.githubRepo.user + '/' + this.state.githubRepo.project + '/stats/commit_activity',
          state: 'activity'
        });

        this.getGithub({
          url: 'repos/' + this.state.githubRepo.user + '/' + this.state.githubRepo.project,
          state: 'github'
        });
      }
    }
  }, {
    key: 'maybeRenderReadme',
    value: function maybeRenderReadme() {
      if (this.state.loaded) {
        var readme = this.state.readme;

        if (readme.length === 0 || readme === readmeErrorMessage) {
          return _jsx('div', {}, void 0, window.i18n.detail.no_readme_found);
        }
        return _jsx(__WEBPACK_IMPORTED_MODULE_7__ReadMore__["a" /* default */], {
          text: window.i18n.detail.display_full_readme,
          className: 'details-doc--content'
        }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8__Markdown__["a" /* default */], {
          source: this.state.readme,
          githubRepo: this.state.githubRepo
        }));
      } else {
        return null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.isBrowsingFiles) {
        return this._renderFileBrowser();
      }
      if (this.state.objectDoesntExist) {
        return this._renderInvalidPackage();
      }
      return this._renderDetails();
    }
  }, {
    key: '_renderInvalidPackage',
    value: function _renderInvalidPackage() {
      return _jsx('section', {
        className: 'text-center d-flex flex-column'
      }, void 0, _jsx('h2', {
        className: 'details-main--title d-inline-block m-2'
      }, void 0, window.i18n.detail.not_found.whoa.replace('{package_name}', this.props.objectID)), _jsx('p', {}, void 0, window.i18n.detail.not_found.yours), _jsx('div', {
        className: 'text-left mx-auto'
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4__Copyable__["a" /* default */], {
        pre: '$ '
      }, void 0, 'mkdir ', this.props.objectID), _jsx(__WEBPACK_IMPORTED_MODULE_4__Copyable__["a" /* default */], {
        pre: '$ '
      }, void 0, 'cd ', this.props.objectID), _ref5, _jsx('p', {
        className: 'text-center'
      }, void 0, window.i18n.detail.not_found.make), _ref6));
    }
  }, {
    key: '_renderDetails',
    value: function _renderDetails() {
      return _jsx('div', {
        className: 'details row'
      }, void 0, _jsx('section', {
        className: 'details-main col-lg-8'
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5__Header__["a" /* default */], {
        name: this.state.name,
        owner: this.state.owner,
        downloadsLast30Days: this.state.downloadsLast30Days,
        humanDownloadsLast30Days: this.state.humanDownloadsLast30Days,
        description: this.state.description,
        license: this.state.license,
        deprecated: this.state.deprecated,
        keywords: this.state.keywords,
        version: this.state.version
      }), _jsx('section', {
        id: 'readme',
        className: 'details-doc'
      }, void 0, _jsx('h3', {
        className: 'details-doc--title details-doc--title__readme py-1'
      }, void 0, _jsx('a', {
        href: '#readme'
      }, void 0, window.i18n.detail.readme)), this.maybeRenderReadme()), this.state.changelog && _jsx('section', {
        id: 'changelog',
        className: 'details-doc'
      }, void 0, _jsx('h3', {
        className: 'details-doc--title details-doc--title__changelog py-1'
      }, void 0, _jsx('a', {
        href: '#changelog'
      }, void 0, window.i18n.detail.changelog)), _jsx(__WEBPACK_IMPORTED_MODULE_7__ReadMore__["a" /* default */], {
        text: window.i18n.detail.display_full_changelog,
        className: 'details-doc--content'
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_8__Markdown__["a" /* default */], {
        source: this.state.changelog,
        githubRepo: this.state.githubRepo
      })))), this._renderSidebar(), _jsx(__WEBPACK_IMPORTED_MODULE_6__JSONLDItem__["a" /* default */], {
        name: this.state.name,
        description: this.state.description,
        keywords: this.state.keywords
      }));
    }
  }, {
    key: '_renderSidebar',
    value: function _renderSidebar() {
      return _jsx(__WEBPACK_IMPORTED_MODULE_2__Aside__["a" /* default */], {
        name: this.state.name,
        githubRepo: this.state.githubRepo,
        homepage: this.state.homepage,
        contributors: this.state.owners,
        activity: this.state.activity,
        downloads: this.state.downloadsLast30Days,
        humanDownloads: this.state.humanDownloadsLast30Days,
        dependencies: this.state.dependencies,
        devDependencies: this.state.devDependencies,
        dependents: this.state.dependents,
        humanDependents: this.state.humanDependents,
        stargazers: this.state.github ? this.state.github.stargazers_count : 0,
        versions: this.state.versions,
        tags: this.state.tags,
        onOpenFileBrowser: this._openFileBrowser
      });
    }
  }, {
    key: '_renderFileBrowser',
    value: function _renderFileBrowser() {
      return _jsx('div', {
        className: 'details row'
      }, void 0, _jsx('section', {
        className: 'details-main col-lg-8'
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_3__FileBrowser__["a" /* default */], {
        objectID: this.props.objectID,
        version: this.state.version,
        onBackToDetails: this._closeFileBrowser
      })), this._renderSidebar());
    }
  }]);

  return Details;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["b"] = (Details);

/***/ }),

/***/ "./lib/Hit/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return License; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Deprecated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Owner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Downloads; });
/* unused harmony export Links */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_esm__ = __webpack_require__("../../node_modules/date-fns/esm/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_instantsearch_dom__ = __webpack_require__("../../node_modules/react-instantsearch/dom.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_instantsearch_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_instantsearch_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__("./lib/util.js");
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();






var License = function License(_ref) {
  var type = _ref.type;
  return type ? _jsx('span', {
    className: 'ais-Hit--license'
  }, void 0, type) : null;
};

var Deprecated = function Deprecated(_ref2) {
  var deprecated = _ref2.deprecated;
  return deprecated ? _jsx('span', {
    className: 'ais-Hit--deprecated',
    title: deprecated
  }, void 0, window.i18n.deprecated) : null;
};

var Owner = function Owner(_ref3) {
  var link = _ref3.link,
      avatar = _ref3.avatar,
      name = _ref3.name;
  return _jsx('a', {
    className: 'ais-Hit--ownerLink',
    href: link
  }, void 0, _jsx('img', {
    width: '20',
    height: '20',
    className: 'ais-Hit--ownerAvatar',
    src: 'https://res.cloudinary.com/hilnmyskv/image/fetch/w_40,h_40,f_auto,q_80,fl_lossy/' + avatar
  }), name);
};

var Downloads = function Downloads(_ref4) {
  var downloads = _ref4.downloads,
      humanDownloads = _ref4.humanDownloads;
  return _jsx('span', {
    className: 'ais-Hit--popular ' + Object(__WEBPACK_IMPORTED_MODULE_3__util__["f" /* getDownloadBucket */])(downloads),
    title: window.i18n.downloads_in_last_30_days.replace('{count}', downloads.toLocaleString(window.i18n.active_language))
  }, void 0, humanDownloads);
};

var Links = function Links(_ref5) {
  var name = _ref5.name,
      homepage = _ref5.homepage,
      githubRepo = _ref5.githubRepo,
      className = _ref5.className;
  return _jsx('div', {
    className: className
  }, void 0, _jsx('span', {
    className: 'ais-Hit--link-npm'
  }, void 0, _jsx('a', {
    href: 'https://www.npmjs.com/package/' + name,
    title: window.i18n.npm_page_for.replace('{name}', name)
  }, void 0, window.i18n.npm)), githubRepo ? _jsx('span', {
    className: 'ais-Hit--link-github'
  }, void 0, _jsx('a', {
    title: window.i18n.github_repo_of.replace('{name}', name),
    href: 'https://github.com/' + Object(__WEBPACK_IMPORTED_MODULE_3__util__["c" /* encode */])(githubRepo.user) + '/' + Object(__WEBPACK_IMPORTED_MODULE_3__util__["c" /* encode */])(githubRepo.project) + githubRepo.path
  }, void 0, window.i18n.github)) : null, homepage ? _jsx('span', {
    className: 'ais-Hit--link-homepage'
  }, void 0, _jsx('a', {
    title: 'Homepage of ' + name,
    href: homepage
  }, void 0, window.i18n.homepage)) : null);
};

var Hit = function Hit(_ref6) {
  var hit = _ref6.hit,
      onTagClick = _ref6.onTagClick;
  return _jsx('div', {
    className: 'ais-Hits--item'
  }, void 0, _jsx('a', {
    className: 'ais-Hit--name',
    href: Object(__WEBPACK_IMPORTED_MODULE_3__util__["i" /* packageLink */])(hit.name)
  }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_instantsearch_dom__["Highlight"], {
    attributeName: 'name',
    hit: hit
  })), _jsx(Downloads, {
    downloads: hit.downloadsLast30Days,
    humanDownloads: hit.humanDownloadsLast30Days
  }), _jsx(License, {
    type: hit.license
  }), _jsx(Deprecated, {
    deprecated: hit.deprecated
  }), _jsx('span', {
    className: 'ais-Hit--version'
  }, void 0, hit.version), _jsx('p', {
    className: 'ais-Hit--description'
  }, void 0, hit.deprecated ? hit.deprecated : _jsx(__WEBPACK_IMPORTED_MODULE_3__util__["a" /* HighlightedMarkdown */], {
    attributeName: 'description',
    hit: hit
  })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Owner, hit.owner), _jsx('span', {
    className: 'ais-Hit--lastUpdate',
    title: window.i18n.last_updated.replace('{update_date}', new Date(hit.modified).toLocaleDateString(window.i18n.active_language))
  }, void 0, window.i18n.time_ago.replace('{time_distance}', Object(__WEBPACK_IMPORTED_MODULE_1_date_fns_esm__["a" /* formatDistance */])(new Date(hit.modified), new Date()))), Object(__WEBPACK_IMPORTED_MODULE_3__util__["g" /* isEmpty */])(hit.keywords) ? null : _jsx('span', {
    className: 'ais-Hit--keywords hidden-sm-down'
  }, void 0, Object(__WEBPACK_IMPORTED_MODULE_3__util__["d" /* formatKeywords */])(hit.keywords, hit._highlightResult.keywords, 4, onTagClick)), _jsx(Links, {
    className: 'ais-Hit--links',
    name: hit.name,
    homepage: hit.homepage,
    githubRepo: hit.githubRepo
  }));
};

/* harmony default export */ __webpack_exports__["e"] = (Hit);

/***/ }),

/***/ "./lib/config.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return algolia; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return docsearch; });
var algolia = {
  appId: 'OFCNCOG2CU',
  apiKey: 'f54e21fa3a2a0160595bb058179bfb1e',
  indexName: 'npm-search'
};

var docsearch = {
  apiKey: '3949f721e5d8ca1de8928152ff745b28',
  indexName: 'yarnpkg'
};

/***/ }),

/***/ "./lib/schema.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  activity: Array.from({ length: 12 }, function () {
    return { total: 0 };
  }),
  changelogFilename: '',
  created: 1489597229367,
  dependencies: {},
  devDependencies: {},
  dependents: 0,
  deprecated: false,
  description: '…',
  downloadsLast30Days: 0,
  downloadsRatio: 0,
  github: {
    stargazers_count: 0
  },
  githubRepo: {
    user: '',
    project: '',
    path: '',
    head: ''
  },
  homepage: '',
  humanDependents: '0',
  humanDownloadsLast30Days: '0',
  keywords: [],
  lastCrawl: '',
  lastPublisher: {
    name: '',
    email: '',
    avatar: 'https://avatars3.githubusercontent.com/u/22247014?v=3&s=200',
    link: ''
  },
  license: '',
  modified: 1489597229367,
  name: '…',
  objectID: '',
  owner: {
    name: '',
    avatar: 'https://avatars3.githubusercontent.com/u/22247014?v=3&s=200',
    link: ''
  },
  owners: [{
    name: '',
    email: '',
    avatar: 'https://avatars3.githubusercontent.com/u/22247014?v=3&s=200',
    link: ''
  }],
  popular: false,
  popularName: '',
  readme: '',
  version: '',
  versions: {},
  tags: {},
  loaded: false
});

/***/ }),

/***/ "./lib/util.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return formatKeywords; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isEmpty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return encode; });
/* harmony export (immutable) */ __webpack_exports__["f"] = getDownloadBucket;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Keywords; });
/* harmony export (immutable) */ __webpack_exports__["h"] = packageJSONLink;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return packageLink; });
/* unused harmony export searchLink */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return prefixURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HighlightedMarkdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return safeMarkdown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_unfetch__ = __webpack_require__("../../node_modules/unfetch/dist/unfetch.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_marked__ = __webpack_require__("../../node_modules/marked/lib/marked.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_marked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_xss__ = __webpack_require__("../../node_modules/xss/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_xss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_xss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_unescape_html__ = __webpack_require__("../../node_modules/unescape-html/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_unescape_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_unescape_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_instantsearch_src_core_highlightTags__ = __webpack_require__("../../node_modules/react-instantsearch/src/core/highlightTags.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_instantsearch_src_core_highlightTags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_instantsearch_src_core_highlightTags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_instantsearch_connectors__ = __webpack_require__("../../node_modules/react-instantsearch/connectors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_instantsearch_connectors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_instantsearch_connectors__);


var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();









var isEmpty = function isEmpty(item) {
  return typeof item === 'undefined' || item.length < 1;
};

var encode = function encode(val) {
  return encodeURIComponent(val);
};

function getDownloadBucket(dl) {
  if (dl < 1000) {
    return null;
  } else if (dl < 5000) {
    return 'hot-t1';
  } else if (dl < 25000) {
    return 'hot-t2';
  } else if (dl < 1000000) {
    return 'hot-t3';
  } else {
    return 'hot-t4';
  }
}

var Keywords = function Keywords(_ref) {
  var _ref$keywords = _ref.keywords,
      keywords = _ref$keywords === undefined ? [] : _ref$keywords,
      _ref$maxKeywords = _ref.maxKeywords,
      maxKeywords = _ref$maxKeywords === undefined ? 4 : _ref$maxKeywords;

  return isEmpty(keywords) ? null : _jsx('span', {
    className: 'ais-Hit--keywords hidden-sm-down'
  }, void 0, keywords.slice(0, maxKeywords).map(function (keyword) {
    return _jsx('a', {
      href: searchLink(keyword)
    }, name + '-' + keyword, keyword);
  }).reduce(function (prev, curr) {
    return [prev, ', ', curr];
  }));
};

function formatKeywords() {
  var keywords = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var highlightedKeywords = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var maxKeywords = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 4;
  var _onClick = arguments[3];

  if (isEmpty(keywords)) return keywords;
  highlightedKeywords.forEach(function (el, i) {
    el.originalValue = keywords[i];
  });
  return highlightedKeywords.sort(function (k1, k2) {
    // sort keywords by match level
    if (k1.matchLevel !== k2.matchLevel) {
      if (k1.matchLevel === 'full') return -1;
      if (k2.matchLevel === 'full') return 1;
      return k1.matchLevel === 'partial' ? -1 : 1;
    }
    if (k1.matchedWords.length !== k2.matchedWords.length) {
      return k2.matchedWords.length - k1.matchedWords.length;
    }
    if (k1.matchedWords.join('').length !== k2.matchedWords.join('').length) {
      return k2.matchedWords.join('').length - k1.matchedWords.join('').length;
    }
    return 0;
  }).slice(0, maxKeywords).map(function (_ref2, keywordIndex) {
    var highlightedKeyword = _ref2.value,
        keyword = _ref2.originalValue;

    var highlighted = parseHighlightedAttribute({
      highlightedValue: highlightedKeyword
    });
    var content = highlighted.map(function (v, i) {
      var key = 'split-' + i + '-' + v.value;
      if (v.isHighlighted) {
        return _jsx('em', {
          className: 'ais-Highlight__highlighted'
        }, key, v.value);
      }
      return _jsx('span', {
        className: 'ais-Highlight__nonHighlighted'
      }, key, v.value);
    });
    return _jsx('span', {
      className: 'ais-Hit--keyword',
      onClick: function onClick() {
        return _onClick(keyword);
      }
    }, '' + keyword + keywordIndex, content);
  }).reduce(function (prev, curr) {
    return [prev, ', ', curr];
  });
}

function parseHighlightedAttribute(_ref3) {
  var _ref3$preTag = _ref3.preTag,
      preTag = _ref3$preTag === undefined ? __WEBPACK_IMPORTED_MODULE_5_react_instantsearch_src_core_highlightTags___default.a.highlightPreTag : _ref3$preTag,
      _ref3$postTag = _ref3.postTag,
      postTag = _ref3$postTag === undefined ? __WEBPACK_IMPORTED_MODULE_5_react_instantsearch_src_core_highlightTags___default.a.highlightPostTag : _ref3$postTag,
      highlightedValue = _ref3.highlightedValue;

  var splitByPreTag = highlightedValue.split(preTag);
  var firstValue = splitByPreTag.shift();
  var elements = firstValue === '' ? [] : [{ value: firstValue, isHighlighted: false }];

  if (postTag === preTag) {
    var isHighlighted = true;
    splitByPreTag.forEach(function (split) {
      elements.push({ value: split, isHighlighted: isHighlighted });
      isHighlighted = !isHighlighted;
    });
  } else {
    splitByPreTag.forEach(function (split) {
      var splitByPostTag = split.split(postTag);
      elements.push({
        value: splitByPostTag[0],
        isHighlighted: true
      });

      if (splitByPostTag[1] !== '') {
        elements.push({
          value: splitByPostTag[1],
          isHighlighted: false
        });
      }
    });
  }

  return elements;
}

function packageJSONLink(_ref4) {
  var githubRepo = _ref4.githubRepo;

  if (githubRepo) {
    var user = githubRepo.user,
        project = githubRepo.project,
        path = githubRepo.path,
        head = githubRepo.head;


    return {
      packageJSONLink: prefixURL('package.json', {
        base: 'https://github.com',
        user: user,
        project: project,
        head: head ? 'tree/' + head : 'tree/master',
        path: path
      })
    };
  }
  return {};
}

var packageLink = function packageLink(name) {
  return window.i18n.url_base + '/package' + ( true ? '/' : '?') + name;
};

var searchLink = function searchLink(query) {
  return window.i18n.url_base + '/packages?q=' + query;
};

var prefixURL = function prefixURL(url, _ref5) {
  var base = _ref5.base,
      user = _ref5.user,
      project = _ref5.project,
      head = _ref5.head,
      path = _ref5.path;

  if (url.indexOf('//') > 0) {
    return url;
  } else {
    return new URL((path ? path.replace(/^\//, '') + '/' : '') + url.replace(/^(\.?\/?)/, ''), base + '/' + user + '/' + project + '/' + (path ? '' : head + '/'));
  }
};

var status = function status(res) {
  return new Promise(function (resolve, reject) {
    if (res.status >= 200 && res.status < 300) {
      // GitHub will return status 202 or 204 if things like contributor activity are
      // valid, but not yet computed, and will return an empty response
      if (res.status === 202 || res.status === 204) {
        reject(res);
      }
      resolve(res);
    } else {
      reject(res);
    }
  });
};

var get = function get(_ref6) {
  var url = _ref6.url,
      type = _ref6.type;
  return Object(__WEBPACK_IMPORTED_MODULE_1_unfetch__["a" /* default */])(url).then(status).then(function (res) {
    return res[type]();
  }).catch(function (err) {
    // in case it's a useless response by GitHub, tell the caller to retry
    if (err.status === 202 || err.status === 204) {
      throw 'retry';
    } else {
      console.warn(err);
    }
  });
};

var HighlightedMarkdown = Object(__WEBPACK_IMPORTED_MODULE_6_react_instantsearch_connectors__["connectHighlight"])(function (_ref7) {
  var highlight = _ref7.highlight,
      attributeName = _ref7.attributeName,
      hit = _ref7.hit;
  return _jsx('span', {
    className: 'ais-Hit--keyword'
  }, void 0, highlight({
    attributeName: attributeName,
    hit: hit,
    highlightProperty: '_highlightResult'
  }).map(function (v, i) {
    return v.isHighlighted ? _jsx('em', {
      className: 'ais-Highlight__highlighted',
      dangerouslySetInnerHTML: safeMarkdown(v.value)
    }, 'split-' + i + '-' + v.value) : _jsx('span', {
      className: 'ais-Highlight__nonHighlighted',
      dangerouslySetInnerHTML: safeMarkdown(v.value)
    }, 'split-' + i + '-' + v.value);
  }));
});

var inlineRenderer = new __WEBPACK_IMPORTED_MODULE_2_marked___default.a.Renderer();
inlineRenderer.paragraph = function (text) {
  return text;
};

var safeMarkdown = function safeMarkdown(input) {
  return {
    __html: __WEBPACK_IMPORTED_MODULE_3_xss___default()(__WEBPACK_IMPORTED_MODULE_2_marked___default()(__WEBPACK_IMPORTED_MODULE_4_unescape_html___default()(input), { renderer: inlineRenderer }))
  };
};

/***/ }),

/***/ "./package.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__("../../node_modules/react-dom/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_Details__ = __webpack_require__("./lib/Details/index.js");
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();





/*
  To get the package id:
    - production: https://yarnpkg.com/en/package/@kadira/storybook => @kadira/storybook
    - dev (no rewrite available): http://localhost:4000/lang/en/package/?@kadira/storybook => @kadira/storybook
*/
var id =  true ? location.pathname.split('/').slice(3).join('/') : location.search.substring(1);

function languageDropdownAddPackage(pkg) {
  var langMenu = document.getElementById('dropdownNavLanguageMenu');
  var langMenuItems = langMenu.querySelectorAll('.dropdown-item');

  var addPackage = function addPackage(langMenuItem) {
    return langMenuItem.href += '/' + pkg;
  };

  for (var i = 0; i < langMenuItems.length; i++) {
    addPackage(langMenuItems[i]);
  }
}

languageDropdownAddPackage(id);

__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(_jsx(__WEBPACK_IMPORTED_MODULE_2__lib_Details__["b" /* default */], {
  objectID: id
}), document.getElementById('pkg-detail'));

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},["./package.js"]);


// WEBPACK FOOTER //
// package.eeda8dfd747c9f1e6313.js